// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-journey-table th, .customer-journey-table td{
    text-align: unset;
}

.bot-switch-wrapper {
    margin: 1.5rem 0;
}

.bot-switch-select {
    display: block;
    width: auto;
}

.chat-step-line__subline {
    border: 1px solid;
    border-radius: 5px;
    padding: 5px;
    margin: 10px;
    background-color: #f5f5f5;
    cursor: pointer;
}

.chat-step-line__procentage {
    font-weight: bold;
}

.chat-step-line__key{ 
    margin-bottom: 1rem;
}

.chat-step-line__key-button {
    border: 1px solid;
    border-radius: 10px;
    margin: .4rem;
}

@keyframes highlight {
    0% {
        background: red
    }
    100% {
        background: none;
    }
}

.highlight {
   animation: highlight 1s;
}

.menu-dialog-stats-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}

.menu-dialog-stat {
    border: 1px solid #646464;
    display: flex;
    margin-bottom: .7rem;
    border-radius: 10px;
}

.menu-dialog-stat__name {
    width: 60%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px 0 0 10px;
}

.menu-dialog-stat__buttons {
    text-align: center;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.menu-dialog-stat__button-name {
    border-bottom: 1px solid;
}

.analytics-tabs-wrapper-container {
    display: flex;
    flex-direction: column;
    margin: 0 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytics-main/analytics-tabs/dialog-stats/DialogStats.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI;IACJ;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB","sourcesContent":[".customer-journey-table th, .customer-journey-table td{\r\n    text-align: unset;\r\n}\r\n\r\n.bot-switch-wrapper {\r\n    margin: 1.5rem 0;\r\n}\r\n\r\n.bot-switch-select {\r\n    display: block;\r\n    width: auto;\r\n}\r\n\r\n.chat-step-line__subline {\r\n    border: 1px solid;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    margin: 10px;\r\n    background-color: #f5f5f5;\r\n    cursor: pointer;\r\n}\r\n\r\n.chat-step-line__procentage {\r\n    font-weight: bold;\r\n}\r\n\r\n.chat-step-line__key{ \r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.chat-step-line__key-button {\r\n    border: 1px solid;\r\n    border-radius: 10px;\r\n    margin: .4rem;\r\n}\r\n\r\n@keyframes highlight {\r\n    0% {\r\n        background: red\r\n    }\r\n    100% {\r\n        background: none;\r\n    }\r\n}\r\n\r\n.highlight {\r\n   animation: highlight 1s;\r\n}\r\n\r\n.menu-dialog-stats-container {\r\n    width: 80%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.menu-dialog-stat {\r\n    border: 1px solid #646464;\r\n    display: flex;\r\n    margin-bottom: .7rem;\r\n    border-radius: 10px;\r\n}\r\n\r\n.menu-dialog-stat__name {\r\n    width: 60%;\r\n    background-color: #f5f5f5;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    border-radius: 10px 0 0 10px;\r\n}\r\n\r\n.menu-dialog-stat__buttons {\r\n    text-align: center;\r\n    width: 40%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.menu-dialog-stat__button-name {\r\n    border-bottom: 1px solid;\r\n}\r\n\r\n.analytics-tabs-wrapper-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 4rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
